(ns common.schema.entities.other-asset
  (:require
   [common.schema.entities.asset :as asset]
   [common.schema.entities.common :as common-schema]
   [common.schema.schema-utils :as su]))

(def import-fixed-fields
  [:common/external-id
   :asset/name
   :other-asset/type])
(def schema
  (concat asset/schema
          (su/option-field-multi :other-asset/tag-tags
                                 "Generic asset tags"
                                 {:authorization su/access-ssg-ssg
                                  :default-field-visibility :in-use})
          (su/option-field :other-asset/type "Type" {:authorization su/access-ssg-ssg})
          [common-schema/common-network-drive-field]
          common-schema/common-network-drives-field
          common-schema/common-folders-path))
